var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-y-hidden"},[(_vm.getGameConsole === 'american')?_c('template-american'):(_vm.getGameConsole === 'terminal')?_c('template-terminal'):_c('template-market-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }